module.exports = {
  development: {
    baseUrl: "/api",
    mockUrl: "https://www.lucealberi-service.com",
    // mockUrl: "http://172.3.1.2:8081",
    // mockUrl: "http://127.0.0.1:8000",
  },
  production: {
    baseUrl: "/api",
    mockUrl: "https://www.lucealberi-service.com",
  },
};
